import React from 'react';
import { Button, Grid } from '@mui/material';

function NumPad({ onKeyPress, array }) {
    const handleButtonClick = (key) => {
        onKeyPress(key);
      };
    return (
        <Grid container spacing={1}>
        {
        array.map((item, index) => (
            <Grid item xs={4} key={index}>
                <Button
                    color   = "secondary"
                    size    = "large"
                    variant = "contained"
                    style   = {{ fontSize: '33px', width: '91px', height:'70px', color:'#fff', backgroundColor:'#808080', padding:'3px' }}
                    onClick = {() => handleButtonClick(item)}
                    >
                    {item}
                </Button>
            </Grid>
        ))}
        </Grid>
    );
}

export default NumPad;